// extracted by mini-css-extract-plugin
export default {"ArchiveCount":"ArchiveCount_ArchiveCount__s9Grl","hyperlink":"ArchiveCount_hyperlink__btus5"};